import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatListModule } from '@angular/material/list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { UzurvPipesModule } from '@uzurv/core';
import { CancelReservationDialogComponent } from './cancel-reservation-dialog.component';
import { MatInputModule } from '@angular/material/input';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    MatListModule,
    MatButtonModule,
    MatInputModule,
    MatRadioModule,
    UzurvPipesModule
  ],
  declarations: [CancelReservationDialogComponent],
  exports: [CancelReservationDialogComponent]
})
export class CancelReservationDialogModule {}
